<template>
    <div class="footer">
        <p>上海隧道 版权所有 沪ICP备15043468号-3 </p>
        <p>所有版权有隧道股份公司所有</p>
    </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .footer{
        display: none;
    }
}
.footer{
    width: 100%;
    height: 100px;
    line-height: 100px;
    background: #19191A;
    overflow: hidden;
    p{
        text-align: center;
        font-size: 12px;
        color: rgba(255,255,255,0.60);
        &:last-child{
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue